import { ActionPayloadType } from '../types';

function setLoading({ commit }: ActionPayloadType, loading: boolean) {
  commit('setLoading', loading);
}

export default {
  setLoading,
};
